import { useAuth as useClerkAuth, useUser } from "@clerk/clerk-react";
import { useMutation } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { useEffect } from "react";

/**
 * Custom auth hook that wraps Clerk's auth hooks
 * Syncs user to Convex database on sign in
 */
export function useAuth() {
  const { isLoaded, isSignedIn, signOut } = useClerkAuth();
  const { user } = useUser();
  const syncUser = useMutation(api.auth.syncUser);

  // Sync user to Convex when they sign in
  useEffect(() => {
    if (isLoaded && isSignedIn && user) {
      syncUser().catch(console.error);
    }
  }, [isLoaded, isSignedIn, user, syncUser]);

  return {
    isLoaded,
    loading: !isLoaded,
    isAuthenticated: isSignedIn ?? false,
    logout: () => signOut(),
    user: user ? {
      id: user.id,
      name: user.fullName || user.firstName || "User",
      email: user.primaryEmailAddress?.emailAddress || null,
      imageUrl: user.imageUrl,
    } : null,
  };
}
